import assetPath from '/app/packages/entity-pages/entity-pages-common/src/components/upsell/assets/upsell_icon_green.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')